import Api from '@/services/Api'

export default {
  getProducts (params) {
    return Api().get('product', {params})
  },
  save (params) {
    return Api().post("product", params)
  }
}



// WEBPACK FOOTER //
// ./src/services/ProductService.js